import React, { useEffect, useState, useMemo } from "react";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../Middleware/Firebase/firebase";
import "../../Css/Dashcrud.css";
// ✅ consume from BusinessContext
import { useBusinessAuth } from "../../Middleware/context/BusinessContext";

// ✅ (Opcional) Se quiser usar dados do contexto
// import { useBusinessAuth } from "../../Functions/Contexts/BusinessContext";

export default function DashboardBuscaProduct() {
   const { user } = useBusinessAuth();

  const [menuData, setMenuData] = useState({});
  const [categoria, setCategoria] = useState("");
  const [subcategoria, setSubcategoria] = useState("");
  const [produtos, setProdutos] = useState([]);
  const [produtoSelecionado, setProdutoSelecionado] = useState("");
  const [produtoEncontrado, setProdutoEncontrado] = useState(null);
  const [searchId, setSearchId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [lastPath, setLastPath] = useState(""); // caminho exato consultado
  const [error, setError] = useState("");

  // Carrega o menu (categorias, subcategorias, e lista de "produtos" do menu)
  useEffect(() => {
    const loadMenu = async () => {
      try {
        const menu = {};
        const catSnap = await getDocs(collection(db, "Menu"));

        for (const cat of catSnap.docs) {
          menu[cat.id] = {};
          const subSnap = await getDocs(
            collection(db, `Menu/${cat.id}/subcategoria`)
          );

          for (const sub of subSnap.docs) {
            const prodSnap = await getDocs(
              collection(db, `Menu/${cat.id}/subcategoria/${sub.id}/produtos`)
            );

            menu[cat.id][sub.id] = prodSnap.docs.map((d) => ({
              id: d.id,
              ...d.data(),
            }));
          }
        }

        setMenuData(menu);
      } catch (e) {
        console.error(e);
        setError("Falha ao carregar o menu.");
      }
    };

    loadMenu();
  }, []);

  // memo helpers
  const categorias = useMemo(() => Object.keys(menuData || {}), [menuData]);
  const subcategorias = useMemo(
    () => (categoria ? Object.keys(menuData[categoria] || {}) : []),
    [menuData, categoria]
  );

  // Atualiza lista de produtos quando subcategoria muda
  useEffect(() => {
    if (!categoria || !subcategoria) {
      setProdutos([]);
      setProdutoSelecionado("");
      return;
    }
    setProdutos(menuData[categoria]?.[subcategoria] ?? []);
    setProdutoSelecionado("");
  }, [categoria, subcategoria, menuData]);

  const buscarProduto = async () => {
    setIsLoading(true);
    setProdutoEncontrado(null);
    setError("");
    try {
      if (!categoria || !subcategoria) {
        setError("Selecione categoria e subcategoria primeiro.");
        return;
      }

      // 1) Busca direta por ID, se informado
      if (searchId.trim()) {
        const path = `Db/${categoria}/${subcategoria}/${searchId.trim()}`;
        setLastPath(path);
        const ref = doc(db, "Db", categoria, subcategoria, searchId.trim());
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setProdutoEncontrado({ id: snap.id, ...snap.data(), _path: path });
          return;
        } else {
          setError("Nenhum documento encontrado com este ID neste caminho.");
          return;
        }
      }

      // 2) Caso contrário, buscar por "produtoSelecionado" ou por outro campo
      if (!produtoSelecionado) {
        setError("Selecione um produto (especificação) ou informe um ID.");
        return;
      }

      // 🔎 Defina qual campo usar para filtrar
      // Se o seu documento tem "category" sendo a especificação (vindo do select), mantenha:
      // const fieldName = "category";
      // Se o seu doc tem "produto" como nome principal do item, use:
      // const fieldName = "produto";

      // Vamos tentar primeiro por category; se no seu data a especificação é 'Produto', ajuste para 'produto'
      const fieldName = "category";

      const path = `Db/${categoria}/${subcategoria}`;
      setLastPath(path);

      // Monta query
      const colRef = collection(db, "Db", categoria, subcategoria);

      // (Opcional) filtrar por fornecedor:
      // const q = query(colRef,
      //   where(fieldName, "==", produtoSelecionado),
      //   where("idSupplier", "==", user?.uid || "")
      // );

      const q = query(colRef, where(fieldName, "==", produtoSelecionado),where("idSupplier", "==", user?.uid ));

      const qSnap = await getDocs(q);
      if (qSnap.empty) {
        setError("Nenhum produto encontrado com este critério.");
        return;
      }

      // Se vierem vários, você decide: pegar o primeiro, ou listar todos
      // Aqui, vou retornar o primeiro
      const first = qSnap.docs[0];
      setProdutoEncontrado({ id: first.id, ...first.data(), _path: path });
    } catch (e) {
      console.error(e);
      setError("Erro na busca. Verifique os critérios e tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <h1>Buscar Produto</h1>

      <div className="card">
        {/* Categoria */}
        <select
          className="selecter"
          value={categoria}
          onChange={(e) => {
            setCategoria(e.target.value);
            setSubcategoria("");
            setProdutos([]);
            setProdutoSelecionado("");
            setProdutoEncontrado(null);
            setError("");
          }}
        >
          <option value="">Categoria</option>
          {categorias.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        {/* Subcategoria */}
        <select
          className="selecter"
          value={subcategoria}
          onChange={(e) => {
            setSubcategoria(e.target.value);
            setProdutoSelecionado("");
            setProdutoEncontrado(null);
            setError("");
          }}
          disabled={!categoria}
        >
          <option value="">{categoria ? "Subcategoria" : "Selecione Categoria"}</option>
          {subcategorias.map((sub) => (
            <option key={sub} value={sub}>
              {sub}
            </option>
          ))}
        </select>

        {/* Produto do menu (especificação) */}
        <select
          className="selecter"
          value={produtoSelecionado}
          onChange={(e) => {
            setProdutoSelecionado(e.target.value);
            setProdutoEncontrado(null);
            setError("");
          }}
          disabled={!subcategoria}
        >
          <option value="">{subcategoria ? "Produto" : "Selecione Subcategoria"}</option>
          {produtos.map((p) => {
            // Considera diferentes chaves no doc do menu
            const nome = p.Produto ?? p.produto ?? p.name ?? p.title ?? "(sem nome)";
            return (
              <option key={p.id} value={nome}>
                {nome}
              </option>
            );
          })}
        </select>

        {/* Busca por ID direto */}
        <input
          className="inputer"
          placeholder="Ou buscar por ID (dentro de Db/categoria/subcategoria)"
          value={searchId}
          onChange={(e) => setSearchId(e.target.value)}
        />

        <button className="button" onClick={buscarProduto} disabled={isLoading}>
          {isLoading ? "Buscando..." : "Buscar"}
        </button>
      </div>

      {lastPath && (
        <p style={{ marginTop: 8, fontSize: 12, color: "#555" }}>
          <strong>Caminho consultado:</strong> {lastPath}
        </p>
      )}

      {error && <div className="result" style={{ color: "crimson" }}>{error}</div>}

      {produtoEncontrado && (
        <pre className="result">{JSON.stringify(produtoEncontrado, null, 2)}</pre>
      )}
    </div>
  );
}